import { NexaBlack } from '@/styles/fonts'
import { cn } from '@/util/cn'
import { GifOverlayProps } from '@giphy/react-components'

type Props = {
    count?: number
}

const BulkSelectorOverlay = ({ count = 0 }: GifOverlayProps & Props) => {
    return count > 0 ? (
        <div
            className={cn(
                `border-giphyIndigo absolute inset-0 box-border border-[6px] border-solid ${NexaBlack.className}`
            )}
        >
            {count && (
                <div className="bg-giphyYellow absolute right-[-6px] top-[-6px] flex size-9 items-center justify-center text-lg font-extrabold text-black">
                    {count}
                </div>
            )}
        </div>
    ) : null
}

export default BulkSelectorOverlay
